/**
 * /company-packages (OCP-1036) - every company package: a price agreed with one
 * named customer account. Offer and withdraw here or on the account page; the
 * MCP tools ocp_list_company_packages / ocp_create_company_package /
 * ocp_withdraw_company_package call the same routes with the same audit row.
 */
import { CompanyPackagesPanel } from '../components/CompanyPackagesPanel';

export function AdminCompanyPackagesPage() {
  return (
    <div className="mx-auto max-w-6xl">
      <h1 className="text-2xl font-semibold tracking-tight">Company packages</h1>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
        There is no automatic volume discount: every self-serve seat count is charged the list price per seat. A larger
        customer gets a package agreed with that one account - plan, seats, price, term, onboarding and training - and
        the account&apos;s checkout for that plan charges it. Offer a package from the account page, or here with the
        account id.
      </p>
      <div className="mt-4">
        <CompanyPackagesPanel />
      </div>
    </div>
  );
}
